<template> 
  <div></div>

</template>

<script>

export default {
  name: 'redirect',
  data () {
    return { 
      url: 'http://www.zhanshangxiu.com/', 
    };
  },
  created() {
        window.location.href = this.url;
  }
}

</script>

<style scoped lang='scss'></style>


// WEBPACK FOOTER //
// src/pages/error/redirect.vue